import React from 'react'
import cn from 'classnames'

const View = ({ className, ...props }) => {
  return <div className={cn('View', className)} {...props} />
}

export default View
